// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"02cfce1d","277":"5b9fd36a","297":"77d171dc","453":"056f178f","714":"4f516600","756":"7f3f50f7","870":"fa727020"}[chunkId] + ".chunk.js";
};